var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.313 9.148c.859.391 1.367 1.25 1.367 2.188V12c0 .898-.782 1.68-1.68 1.68H2c-.898 0-1.68-.782-1.68-1.68v-.664c0-.938.508-1.797 1.368-2.188A11.34 11.34 0 0 1 7 7.82c2.11 0 3.906.586 5.313 1.328M5.164 7c-1.016 0-1.797-.898-1.68-1.875l.274-2.031C4.03 1.492 5.398.32 7 .32s2.969 1.172 3.242 2.774l.274 2.031C10.633 6.102 9.852 7 8.836 7z"
  })));
};
export default SvgPerson;